'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Dropdown;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _styles = require('./styles');

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Dropdown(props) {
  var placeholder = props.placeholder ? [{ name: props.placeholder, value: '' }] : [];
  var options = (props.options || []).map(function (opt) {
    if (typeof opt === 'string') {
      return { name: opt, value: opt };
    }
    return opt;
  });

  var classNames = (0, _classnames2.default)(_styles2.default.toString(), props.className);

  var _onChange = props.onChange || function (f) {
    return f;
  };

  return _react2.default.createElement(
    'div',
    { className: classNames },
    _react2.default.createElement(
      'label',
      { htmlFor: props.id },
      props.name
    ),
    _react2.default.createElement(
      'select',
      {
        id: props.id,
        onChange: function onChange(event) {
          return _onChange(event);
        },
        disabled: props.disabled
      },
      placeholder.concat(options).map(function (option) {
        return _react2.default.createElement(
          'option',
          { key: option.value, value: option.value },
          option.name
        );
      })
    )
  );
}

Dropdown.propTypes = {
  id: _propTypes2.default.string.isRequired,
  onChange: _propTypes2.default.func,
  className: _propTypes2.default.string,
  placeholder: _propTypes2.default.string,
  options: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    name: _propTypes2.default.string,
    value: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
  })).isRequired,
  name: _propTypes2.default.string,
  disabled: _propTypes2.default.bool
};

Dropdown.defaultProps = {
  onChange: function onChange() {},
  className: null,
  placeholder: '',
  name: '',
  disabled: false
};


//////////////////
// WEBPACK FOOTER
// ./~/tanda-components/Dropdown/index.js
// module id = 1582
// module chunks = 0